export const cardVisitConstants = {
    GET_CARD_VISITS: 'GET_CARD_VISITS',
    CREATE_CARD_VISITS: 'CREATE_CARD_VISITS',
    CARD_VISIT_FAILURE: 'CARD_VISIT_FAILURE'
};